import genericsFn from '../../styles/generics/styles'

export default genericsFn



// WEBPACK FOOTER //
// ./containers/list/styles.js